import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {CircularSpinner} from "@khanacademy/wonder-blocks-progress-spinner";
import Switch from "@khanacademy/wonder-blocks-switch";
import {LabelMedium} from "@khanacademy/wonder-blocks-typography";

interface SettingsCheckboxProps {
    isLoading: boolean;
    checked: boolean;
    onChange: (checked: boolean) => void;
    label: string;
    inputId: string;
}

export const SubscriptionSwitch: React.FC<SettingsCheckboxProps> = ({
    isLoading,
    checked,
    onChange,
    label,
    inputId,
}) => {
    return (
        <div className={css(styles.container)}>
            <Switch checked={checked} onChange={onChange} id={inputId} />
            <LabelMedium id={inputId}>{label}</LabelMedium>
            {isLoading && (
                <div className={css(styles.spinnerContainer)}>
                    <CircularSpinner size="xsmall" />
                </div>
            )}
        </div>
    );
};

const styles = StyleSheet.create({
    container: {
        display: "flex",
        alignItems: "center",
        marginBlockEnd: "8px",
        gap: "8px",
    },
    spinnerContainer: {
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        // paddingLeft: 12,
        // paddingRight: 12,
    },
});

export default SubscriptionSwitch;
